import React from 'react';
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import { Grid } from "@mui/material";
import { Link } from "react-router-dom";
import Routes from "./Routes";
import logo from "../images/healthequity-footer-logo.svg";



const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  content: {
    flex: '1 0 auto',
  },
  footerText: {
    fontFamily: "Lato",
    color: "#474747",    
    fontSize: "14.4px",
    textAlign: "left",
    paddingLeft: "24px",
    backgroundColor: "#fff",  
  },
  footerBox: {    
    backgroundColor: "#fff",
  },    
  logo: {    
    verticalAlign: "middle",
    display: "inline-block",
    width: "153px",
    height: "20px",
    margin: "0 auto 40px",
    float: "right"
  },
  footerLink: {    
    color: "#474747",    
    textDecoration: "none"
  },
  gridItem: {
    backgroundColor: "#fff"
  }
});

function Footer() {
  const classes = useStyles();
  
  return (         
    <div className={classes.wrapper}>
      <Box className={classes.content}>
        {/* Other page content goes here */}
      </Box>
      <Box className={classes.footerText}>
        <Grid container direction={"row"} spacing={3} className={classes.footerBox}>
          <Grid item xs={1} className={classes.gridItem}><a className={classes.footerLink} href="https://healthequity.com/contact/" target="_blank">Contact Us</a></Grid>
          <Grid item xs={2} className={classes.gridItem}><a className={classes.footerLink} href="https://www2.healthequity.com/language-assistance" target="_blank">Language Assistance/Non-Discrimination</a></Grid>
          <Grid item xs={1} className={classes.gridItem}><a className={classes.footerLink} href="https://healthequity.com/legal#pp" target="_blank">Privacy Policy</a></Grid>
          <Grid item xs={1} className={classes.gridItem}><a className={classes.footerLink} href="https://healthequity.com/legal" target="_blank"> Terms of Use</a></Grid>
          <Grid item xs={4} className={classes.gridItem}><a className={classes.footerLink} href="https://healthequity.com/legal#security" target="_blank"> Security</a></Grid>
          <Grid item xs={2} className={classes.gridItem}>© {(new Date().getFullYear())} HealthEquity, Inc. All rights reserved</Grid>
          <Grid item xs={1} justifyContent="flex-end" alignItems="center" className={classes.gridItem}>           
              <img className={classes.logo} alt="HealthEquity Logo" src={logo} />                                
          </Grid>
        </Grid>          
      </Box>
    </div>
  );
}

export default Footer;
